<!-- メイン領域-->
<mat-drawer-container class="main-container" autosize>
  <!-- 一覧画面表示領域-->
  <div class="details-layout" #master>
    <p-table #table [value]="searchResultsList" [paginator]="true" [rows]="10" [(first)]="pages"
      [showCurrentPageReport]="true" currentPageReportTemplate="{first}～{last}件表示({totalRecords}件中)"
      [rowsPerPageOptions]="[10, 50, 100, 500, 1000]" styleClass="p-datatable-striped master-datatable"
      selectionMode="single">
      <ng-template pTemplate="caption">
        <div class="p-d-flex p-jc-between">
          <div class="p-d-flex button-bar">
            <!-- 検索画面表示-->
            <button type="button" pButton icon="pi pi-search" (click)="search.toggle()" class="p-mr-2 p-button-br-7"
              *ngIf="!checkMobile"></button>

            <button type="button" pButton label="検索する" (click)="searchMobile.toggle()"
              class="p-mr-2 p-button-br-7 button-mobile" *ngIf="checkMobile"></button>

            <!-- 新規登録表示-->
            <button type="button" pButton label="新規" (click)="new()" class="p-mr-2 p-button-br-7 button-mobile"
              *ngIf="classId !== '9' && !m301 && !m401 && !m701"></button>
            <button type="button" pButton label="ふれあい体験希望を登録する" (click)="new()"
              class="p-mr-2 p-button-br-7 button-mobile" *ngIf="classId !== '9' && m301"></button>
            <button type="button" pButton label="ふれあい体験希望を登録する" (click)="new()"
              class="p-mr-2 p-button-br-7 button-mobile" *ngIf="classId !== '9' &&  m401"></button>
            <!-- <div *ngIf="linkPDF && classId !== '9' && !checkMobile" class="link-pdf">
              <span class="p-dialog-title">{{ title }}</span>
              <a class="linktext-blue underline" (click)="openURI()">こちら</a>
            </div> -->
          </div>
        </div>

        <!-- <div *ngIf="linkPDF && classId !== '9' && checkMobile" class="link-pdf">
          <span class="p-dialog-title">{{ title }}</span>
          <a class="linktext-blue underline" (click)="openURI()">こちら</a>
        </div> -->
      </ng-template>

      <!-- 一覧画面ヘッダー表示-->
      <ng-template pTemplate="header">
        <tr>
          <!-- APIヘッダーの表示 -->

          <ng-container *ngFor="let column of columnOrder; index as i">
            <th scope="col"
              *ngIf="!checkMobile && column.field != 'consultation_count_message' && column.field != 'consultation_contente' && column.field != 'consultation_match_id'"
              [pSortableColumn]="column.field" class="p-text-bold">
              {{ column.header }}
              <p-sortIcon *ngIf="!checkMobile" [field]="column.field" 　aria-label="{{ column.header }}で並べ替え"
                title="{{ column.header }}で並べ替え"></p-sortIcon>
            </th>

            <th scope="col" class="p-text-bold"
              *ngIf="checkMobile && (column.field != 'agenda_solution_agenda_id' || m301) && (column.field != 'agenda_need_agenda_id' || m401) && column.field != 'consultation_count_message' && column.field != 'consultation_contente' && column.field != 'consultation_match_id'"
              [pSortableColumn]="column.field">
              {{ column.header }}
              <p-sortIcon *ngIf="!checkMobile" [field]="column.field"></p-sortIcon>
            </th>
          </ng-container>
          <!-- 操作ヘッダーの表示 -->
          <th scope="col" *ngIf="classId !== '9'" class="btn-area p-text-bold">
            <p>操作</p>
          </th>
        </tr>
      </ng-template>
      <!-- 一覧画面ボディ表示-->
      <ng-template pTemplate="body" let-searchResults>
        <tr>
          <!-- 一覧表示-->
          <ng-container *ngFor="let column of columnOrder; index as i">
            <!-- 一覧項目値表示(詳細画面遷移項目) -->
            <td *ngIf="0 == i && !m701; else hideContent">
              <label *ngIf="!checkMobile" (click)="detail(searchResults[column.field])">
                <u>{{ searchResults[column.field] }}</u>
              </label>

              <label *ngIf="checkMobile"
                (click)="detail(m101||m501||m601?searchResults[column.field]:searchResults[columnOrder[0].field])">
                <u>{{ searchResults[column.field] }}</u>
              </label>
            </td>

            <!-- 一覧項目値表示 -->
            <ng-template #hideContent>
              <td
                *ngIf="!checkMobile && column?.field != 'consultation_count_message' && column.field != 'consultation_contente' && column.field != 'consultation_match_id'"
                [ngSwitch]="column?.input_type" [pTooltip]="searchResults[column.field]" #tt
                [tooltipDisabled]="!isOverflow(tt) || column?.input_type == 'MESSAGE'" showDelay="500" hideDelay="500">
                <span *ngSwitchCase="'NUMBER'">
                  {{ searchResults[column.field] | number }}
                </span>
                <span *ngSwitchCase="'IMAGE'">
                  <img [src]="searchResults[column.field]" alt="image" class="min-img" />
                </span>
                <span *ngSwitchCase="'BTN-DETAIL'">
                  <button pButton class="btn-detail" label="{{searchResults[column.field]}}"
                    (click)="detailM701(searchResults.consultation_contente)"></button>
                </span>
                <span *ngSwitchCase="'DROPDOW'">
                  <div [ngClass]="setClassStatusDropdown(searchResults[column.field])">
                    <p-dropdown optionLabel="name" [options]="getListStatusChange(searchResults[column.field])"
                      optionValue="code" class="drop-down-style-first"
                      (onChange)="changeStatus($event, searchResults.consultation_consultation_id)"
                      [(ngModel)]="searchResults[column?.field]" aria-label="ステータスを選ぶ" appendTo="body"></p-dropdown>
                  </div>
                </span>
                <div *ngSwitchCase="'MESSAGE'" class="message-cell">
                  <span [pTooltip]="searchResults[column.field]" #tt1 [tooltipDisabled]="!isOverflow(tt1)"
                    showDelay="500" hideDelay="500" class="message-content" (click)="moveC601(searchResults)">
                    <u>{{ searchResults[column.field] ? searchResults[column.field] : 'メッセージがありません' }}</u>
                  </span>
                  <p-avatar *ngIf="searchResults.consultation_count_message != '0'" class="message-count" size="small"
                    [label]="searchResults.consultation_count_message" shape="circle"></p-avatar>
                </div>
                <span *ngSwitchDefault>
                  {{ searchResults[column.field] }}
                </span>

              </td>

              <td *ngIf="checkMobile && column.field != 'agenda_solution_agenda_id' && column.field != 'agenda_need_agenda_id' && column.field != 'consultation_count_message'
                && column.field !='consultation_contente' && column.field != 'consultation_match_id'"
                [ngSwitch]="column?.input_type" [pTooltip]="searchResults[column.field]" #tt
                [tooltipDisabled]="!isOverflow(tt)" showDelay="500" hideDelay="500">
                <span *ngSwitchCase="'NUMBER'">
                  {{ searchResults[column.field] | number }}
                </span>
                <span *ngSwitchCase="'IMAGE'">
                  <img [src]="searchResults[column.field]" alt="image" class="min-img" />
                </span>
                <span *ngSwitchCase="'BTN-DETAIL'">
                  <button pButton label="{{searchResults[column.field]}}"
                    (click)="detailM701(searchResults.consultation_contente)"></button>
                </span>
                <span *ngSwitchDefault>
                  {{ searchResults[column.field] }}
                </span>
                <span *ngSwitchCase="'DROPDOW'">
                  <div [ngClass]="setClassStatusDropdown(searchResults[column.field])">
                    <p-dropdown optionLabel="name" [options]="getListStatusChange(searchResults[column.field])"
                      optionValue="code" class="drop-down-style-first"
                      (onChange)="changeStatus($event, searchResults.consultation_consultation_id)"
                      [(ngModel)]="searchResults[column?.field]" aria-label="ステータスを選ぶ" appendTo="body"></p-dropdown>
                  </div>
                </span>
                <div *ngSwitchCase="'MESSAGE'" class="message-cell">
                  <span [pTooltip]="searchResults[column.field]" #tt1 [tooltipDisabled]="!isOverflow(tt1)"
                    showDelay="500" hideDelay="500" class="message-content" (click)="moveC601(searchResults)">
                    <u>{{ searchResults[column.field] ? searchResults[column.field] : 'メッセージがありません' }}</u>
                  </span>
                  <p-avatar *ngIf="searchResults.consultation_count_message != '0'" class="message-count" size="small"
                    [label]="searchResults.consultation_count_message" shape="circle"></p-avatar>
                </div>
              </td>
            </ng-template>
          </ng-container>

          <!-- 操作表示 -->
          <td class=" btn-area" *ngIf="classId !== '9' ">

            <!-- 編集ボタン -->
            <button *ngIf="!checkMobile" pButton (click)="edit(searchResults[columnOrder[0].field])" icon="pi pi-pencil"
              class="p-button-rounded p-button-success" pTooltip="編集" tooltipPosition="bottom"></button>

            <button *ngIf="checkMobile" pButton
              (click)="edit(searchResults[columnOrder[m101||m201||m501||m601||m301||m401?0:1].field])" icon="pi pi-pencil"
              class="p-button-rounded p-button-success" pTooltip="編集" tooltipPosition="bottom"></button>

            <!-- 複製ボタン -->
            <button *ngIf="!checkMobile" pButton (click)="duplicate(searchResults[columnOrder[0].field])"
              icon="pi pi-clone" class="p-button-rounded p-button-info" pTooltip="複製" tooltipPosition="bottom"
              [disabled]='searchResults["member_class_id"] == "支援実施者（個人）" && router?.url?.startsWith("/pages/platform/master/m201")'></button>

            <button *ngIf="checkMobile" pButton
              (click)="duplicate(searchResults[columnOrder[m101||m201||m501||m601||m301||m401?0:1].field])" icon="pi pi-clone"
              class="p-button-rounded p-button-info" pTooltip="複製" tooltipPosition="bottom"></button>

            <!-- 削除ボタン -->
            <button *ngIf="!checkMobile" pButton (click)="
                  delete(searchResults[columnOrder[0].field], searchResults)
                " icon="pi pi-trash" class="p-button-rounded p-button-danger" pTooltip="削除"
              tooltipPosition="bottom"></button>

            <button *ngIf="checkMobile" pButton (click)="
                  delete(searchResults[columnOrder[m101||m201||m501||m601||m301||m401?0:1].field], searchResults)
                " icon="pi pi-trash" class="p-button-rounded p-button-danger" pTooltip="削除"
              tooltipPosition="bottom"></button>

          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <mat-sidenav #searchMobile class="search-sidenav search-sidenav-mobile" mode="side" fixedInViewport="false"
    [ngClass]="{ 'drawer-scroll': isScroll }">
    <!-- 検索画面非表示-->
    <button type="button" pButton icon="pi pi-arrow-left" (click)="searchMobile.toggle()"
      class="p-mr-2 p-button-br-7"></button>

    <!-- 検索画面[検索項目生成(アイテムアダプター)]-->
    <app-generate-search [searchEndPoint]="searchEndPoint" [searchTemplateId]="searchTemplateId"
      (openTab)="addScroll($event)"
      (generateSearchInformation)="searchMobile.toggle();searchResult($event)"></app-generate-search>
  </mat-sidenav>
  <!-- 検索画面-->

  <mat-drawer #search class="search-sidenav" mode="side" [ngClass]="{ 'drawer-scroll': isScroll }">
    <!-- 検索画面非表示-->
    <button type="button" pButton icon="pi pi-arrow-left" (click)="search.toggle()"
      class="p-mr-2 p-button-br-7"></button>

    <!-- 検索画面[検索項目生成(アイテムアダプター)]-->
    <app-generate-search [searchEndPoint]="searchEndPoint" [searchTemplateId]="searchTemplateId"
      (openTab)="addScroll($event)" (generateSearchInformation)="searchResult($event)"></app-generate-search>
  </mat-drawer>
</mat-drawer-container>

<!-- 詳細画面[表示項目生成(アイテムアダプター)]-->
<app-generate-display (reloadID)="searchReplacement($event)"></app-generate-display>

<!-- 登録画面[入力項目生成(アイテムアダプター)]-->
<app-generate-input (reloadID)="searchReplacement($event)"></app-generate-input>

<!-- 削除ダイアログ-->
<app-delete-dialog (reloadID)="searchReplacement($event)"></app-delete-dialog>

<!-- Toastメッセージ表示 -->
<p-toast position="top-center"></p-toast>

<app-consultation-dialog></app-consultation-dialog>